import {FormControlType, IFormConfig, InputType, ValidationRules} from 'marine-panel-common-web';
import {IChangeExtraModalValues} from './index';
export const changeExtraFormConfig = (value: IChangeExtraModalValues): IFormConfig => {
    return {
        controlType: 'form',
        class: 'default-form create-marina',
        dataAccessor: (data: any) => data,
        outputDataMapper: (data: any, previousStateSnapshot: any) => {
            Object.assign(previousStateSnapshot, data);
            return previousStateSnapshot;
        },
        controls: [
            {
                key: 'price',
                controlType: 'group',
                class: 'row',
                controls: {
                    price: {
                        controlType: 'control',
                        defaultValue: value.price,
                        hostClass: 'col-xl-12 form-control fixed-number-indicator',
                        formControlType: FormControlType.INPUT,
                        isLabelHidden: false,
                        validationRules: [{name: ValidationRules.IS_VALID_DECIMAL_PART_NUMBER, params: {}}],
                        label: 'modal.createExtra.inputs.price',
                        placeholder: 'modal.createExtra.placeholders.price',
                        type: InputType.NUMBER,
                        customNumberIndicator: '€',
                    },
                },
            },
            {
                key: 'description',
                controlType: 'group',
                class: 'row',
                controls: {
                    description: {
                        controlType: 'control',
                        formControlType: FormControlType.INPUT,
                        validationRules: [{name: ValidationRules.IS_REQUIRED, params: {}}],
                        placeholder: '',
                        defaultValue: value.description,
                        isLabelHidden: false,
                        label: 'modal.createExtra.inputs.description',
                        type: InputType.TEXT,
                        hostClass: 'col-xl-12 form-control',
                    },
                },
            },
        ],
    };
};
